import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-navy text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
              ADEN İKLİMLENDİRME
            </h3>
            <p className="text-slate-300 leading-relaxed">
              Aden İklimlendirme, İzmir genelinde 15 yıllık tecrübesiyle klima, kombi ve beyaz eşya teknik servis hizmeti sunar.
              7/24 servis desteği ve garantili işçilik anlayışıyla hızlı ve kalıcı çözümler üretir.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
              Hızlı Bağlantılar
            </h4>
            <ul className="space-y-2">
              <Link to="/hakkimizda" className="block text-slate-300 hover:text-orange transition-colors">
                Hakkımızda
              </Link>
              <Link to="/hizmetler" className="block text-slate-300 hover:text-orange transition-colors">
                Hizmetler
              </Link>
              <Link to="/islerimiz" className="block text-slate-300 hover:text-orange transition-colors">
                İşlerimiz
              </Link>
              <Link to="/blog" className="block text-slate-300 hover:text-orange transition-colors">
                Blog
              </Link>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-4" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
              Hizmetlerimiz
            </h4>
            <ul className="space-y-2 text-slate-300">
              <li>Klima Montaj, Bakım & Gaz Dolumu</li>
              <li>Kombi Bakım & Arıza Onarım</li>
              <li>Beyaz Eşya Teknik Servisi</li>
              <li>Petek Temizliği</li>
              <li>7/24 Acil Teknik Servis</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-4" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
              İletişim
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2 text-slate-300">
                <Phone size={18} className="text-orange" />
                <a href="tel:+905063853685" className="hover:text-white"
                  onClick={() => {
                    if (window.gtag) {
                      window.gtag('event', 'conversion', {
                        send_to: 'AW-17944147746/P41VCLrutvYbEKLut-xC'
                      });
                    }
                  }}>
                  +90 506 385 36 85
                </a>
              </li>
              <li className="flex items-center space-x-2 text-slate-300">
                <Mail size={18} className="text-orange" />
                <a
                  href="mailto:info@adeniklimlendirme.com"
                  className="hover:text-white"
                >
                  info@adeniklimlendirme.com
                </a>
              </li>
              <li className="flex items-start space-x-2 text-slate-300">
                <MapPin size={18} className="text-orange mt-1" />
                <span>
                  RAFET PAŞA MAH. 5351/1 SK. NO: 9 A <br />
                  BORNOVA / İZMİR
                </span>
              </li>
            </ul>

            {/* Social Media */}
            <div className="flex items-center space-x-4 mt-6">
              <a href="https://wa.me/905063853685" className="text-slate-300 hover:text-orange transition-colors">
                <Facebook size={20} />
              </a>
              <a href="https://www.instagram.com/adeniklimlendirme" className="text-slate-300 hover:text-orange transition-colors">
                <Instagram size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-700 mt-12 pt-8 text-center text-slate-400">
          <p>
            © {new Date().getFullYear()} Aden İklimlendirme | İzmir Teknik Servis Hizmetleri
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
